import { render, staticRenderFns } from "./TransferOrRevokeOrder.vue?vue&type=template&id=4a42ca1c"
import script from "./TransferOrRevokeOrder.vue?vue&type=script&lang=js"
export * from "./TransferOrRevokeOrder.vue?vue&type=script&lang=js"
import style0 from "./TransferOrRevokeOrder.vue?vue&type=style&index=0&id=4a42ca1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports